export const ITEM_HISTORY_TYPE_INDEX = 0;
export const ITEM_HISTORY_ID_INDEX = 1;
export const ITEM_HISTORY_NAME_INDEX = 2;
